module.exports = __webpack_public_path__ + "assets/lei.b3083258.svg";